import React, { useCallback } from 'react';
import { Column, LoadingDots, LoadingSpinner, Row } from '@mattilsynet/mt-ui';
import IngenTilstede from './ingen-tilstede';
import { useVirksomhetDeltakere, useVirksomhetDeltakereInfo } from '../index';
import { useSelector } from 'react-redux';
import { IStoreState } from '../../../reducers/types';
import { useDeltakereFns, useRemoveEmptyDeltaker } from '../hooks/component-hooks';
import { DeleteModal } from '../../../modals';
import AddDeltaker from './add-deltaker';
import { DeltakerItem } from './deltaker-item';
import { useKvitteringId } from '../../../common/kvittering-context';
import { DeltakerTypes } from '../types';
export const VirksomhetDeltakere = () => {
  const kvitteringStatus = useSelector((state: IStoreState) => state.kvittering.selectedKvittering.status);
  const kvitteringId = useKvitteringId();
  const deltakere = useVirksomhetDeltakere(kvitteringId);
  const {
    virksomhetsNavn,
    ingenTilStede
  } = useVirksomhetDeltakereInfo(kvitteringId);
  const {
    onAdd,
    onUpdate,
    onRemove,
    shouldAutoFocus,
    remove,
    setDeltakerToBeRemoved,
    hasError,
    deltakerToBeRemoved,
    isAddLoading
  } = useDeltakereFns(deltakere, kvitteringId, DeltakerTypes.VIRKSOMHET, ingenTilStede);
  useRemoveEmptyDeltaker(deltakere.data ?? [], onRemove);
  const shouldDisableOnIngenTilStede = () => {
    const containsVirksomhetsDeltaker = deltakere.data?.some(deltaker => !!deltaker.navn.trim());
    return containsVirksomhetsDeltaker || kvitteringStatus === 'SAVING_VIRKSOMHETS_DELTAGER';
  };
  const onCancelRemove = useCallback(() => setDeltakerToBeRemoved(undefined), [setDeltakerToBeRemoved]);
  return <>
      <Column spacing={2} data-sentry-element="Column" data-sentry-source-file="virksomhet-deltakere.tsx">
        <Column spacing={2} data-sentry-element="Column" data-sentry-source-file="virksomhet-deltakere.tsx">
          <Row className="info-header" data-sentry-element="Row" data-sentry-source-file="virksomhet-deltakere.tsx">Fra {virksomhetsNavn}</Row>

          {deltakere.isLoading && <Row center>
              <LoadingSpinner title={'Laster deltakerer...'} small />
            </Row>}

          {!deltakere.isLoading && deltakere.data?.map(deltaker => <DeltakerItem key={deltaker.id} deltaker={deltaker} onUpdateDeltaker={onUpdate} onRemoveDeltaker={onRemove} autoFocus={shouldAutoFocus(deltaker)} danger={hasError} disabled={ingenTilStede} />)}
        </Column>

        {(isAddLoading || deltakere.isFetching && deltakere.data?.length === 0) && <Row justify="center">
            <LoadingDots />
          </Row>}

        {!deltakere.isLoading && <>
            <AddDeltaker onAdd={onAdd} disabled={ingenTilStede} />
            <IngenTilstede disabled={shouldDisableOnIngenTilStede()} />
          </>}
      </Column>

      <DeleteModal isOpen={!!deltakerToBeRemoved} onCancel={onCancelRemove} onDelete={remove} title="Er du sikker på at du vil slette deltaker?" confirmText="Ja, jeg vil slette deltaker" cancelText="Avbryt" data-sentry-element="DeleteModal" data-sentry-source-file="virksomhet-deltakere.tsx" />
    </>;
};